module.exports = __webpack_public_path__ + "images/CEBSB_goodnews_bg_down1.1789545008192.png";